import { formatCurrency } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'formatPrice',
})
export class FormatPricePipe implements PipeTransform {
  private readonly translateService = inject(TranslocoService);

  transform(value: number): string {
    return !isNaN(value)
      ? formatCurrency(value, 'de-DE', '€', 'EUR')
      : this.translateService.translate('company-tool.views.campaigns.campaign-collapse.free-platform');
  }
}
